module.exports = __webpack_public_path__ + "static/media/tools.34e16f18.png";